import { financeAssets, animalAssets } from "../../../services/constant";
import SearchIcon from '@mui/icons-material/Search';
import TranscationTable from "../component/transcationTable";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useState } from "react";
import { Popover, Typography } from "@mui/material";


import { DatePicker } from 'antd';
const Transcation = () => {
    const [refund, setRefund] = useState(false);
    const [details, setDetails] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const [expend, setExpend] = useState(false);
    const [openPopUpId1, setOpenPopUpId1] = useState(null);
    const [anchorElValue, setAnchorElValue] = useState(null);
    const [search, setSearch] = useState(false);

    const onChange = (date, dateString) => {
        console.log(date, dateString);
      };
    const showAllModal = () => {
        setDetails(true);
        setShowAll(true);
        setExpend(true);
    }

    const handlePopUpCloseValue = () => {
        setAnchorElValue(null);
        setOpenPopUpId1(null);
    };

    const handlPopUpValue = (e, id) => {
        setAnchorElValue(e.currentTarget);
        setOpenPopUpId1(id);
    };

    const onSearch = () => setSearch(true);
    return (
        <div className="flex flex-col gap-[16px]">

            {/* header part */}
            <div className="flex flex-row justify-between mr-[43px]">
                <div className="flex flex-row gap-[16px]">
                    <div className="w-full rounded-[11px] bg-white p-[1.8rem] flex flex-col gap-[1.4rem]">
                        <div className="flex flex-row gap-[0.8rem]">
                            <img src={financeAssets.ic_edit} className="w-[1.6rem] h-[1.6rem] self-center" alt="" />
                            <p className="font-13-400 text-[#7385AA] self-center"> Receita Total </p>
                        </div>
                        <p className="font-color font-23-900">2454,34€</p>
                    </div>

                    <div className="rounded-[11px] bg-white p-[1.8rem] flex flex-col gap-[1.4rem] ">
                        <div className="flex flex-row gap-[1.8rem]">
                            <img src={financeAssets.ic_download} className="w-[1.6rem] h-[1.6rem] self-center" alt="" />
                            <p className="font-13-400 text-[#7385AA] self-center"> Total para recebimento </p>
                        </div>
                        <div className="flex flex-row justify-between w-[17.4rem]">
                            <p className="font-color font-23-400 self-center">75€</p>
                            {!refund ? (
                                <button className="font-12-700 text-white bg-[#FBBD18] w-fit h-[3rem] rounded-[10rem] px-[1rem] self-center hover:bg-[#29215B]" onClick={showAllModal}> Pedir Reembolso  </button>
                            ) : (
                                <p className="font-13-700 text-[#FBBD18]">A aguardar reembolso</p>
                            )}

                        </div>
                    </div>
                </div>
                <div className="flex flex-row gap-[8px]">
                    <p className="font-13-500 text-[#95AFC9] self-center">Filtrar:</p>
                    <button className="bg-white w-[185px] h-[35px] rounded-[100px] flex flex-row gap-[16px] self-center place-content-center" onClick={(e) => handlPopUpValue(e, 1)}><span className="font-13-500 text-[#697DA4] self-center">Todos os estados</span> <KeyboardArrowDownIcon style={{ fontSize: '18px' }} className="self-center" /> </button>

                    {/* <input className="bg-white w-[125px] h-[35px] rounded-[100px] flex flex-row gap-[16px] self-center place-content-center"><span className="font-13-500 text-[#697DA4] self-center">Set 2025</span> <KeyboardArrowDownIcon style={{ fontSize: '18px' }} className=" self-center" /> </input> */}
                    <DatePicker onChange={onChange} placeholder="Selecionar data..." className="bg-white w-[155px] border-white h-[35px] rounded-[100px] flex flex-row gap-[16px] self-center place-content-center font-13-500 text-[#697DA4]" format="MM-DD-YYYY"/>
                    {
                        !search ? (
                            <button className="bg-white w-[35px] h-[35px] rounded-[100px] flex flex-row gap-[16px] self-center place-content-center" onClick={onSearch} >
                                <SearchIcon style={{ fontSize: '25px' }} className="self-center text-[#697DA4]" />
                            </button>
                        ) : (
                            <div className="relative self-center">
                                <input placeholder="Pesquisar..." className="w-[15.3rem] h-[3.5rem] rounded-[10rem] px-[16px] font-13-500" />
                                <SearchIcon style={{ fontSize: '25px' }} className="self-center text-[#697DA4] absolute right-4 top-2 " />
                            </div>
                        )
                    }
                    <Popover
                        id={1}
                        open={openPopUpId1 === 1}
                        anchorEl={anchorElValue}
                        onClose={handlePopUpCloseValue}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        sx={{
                            marginTop: '2rem',
                            '& .MuiPaper-root': {
                                border: '1px solid #fff',
                                borderRadius: '1.1rem',
                                minWidth: '20rem',
                                boxShadow: '0px 0px 23px 0px rgba(0, 0, 0, 0.15)',
                            },
                        }}
                    >
                        <Typography className="flex-column" style={{ width: '100%' }}>
                            <div className="flex flex-col gap-[8px] py-[16px]">
                                <div className=" bg-[#FEF3D1] font-13-400 pl-[16px] text-left">
                                    Todos os estados
                                </div>
                                <div className="pl-[16px] flex flex-row gap-3">
                                    <img alt="" src={financeAssets.ic_download} className="w-[1.4rem] h-[1.4rem] self-center" />
                                    <span className="font-13-400 text-[#697DA4]">Pedidos de reembolso</span>
                                </div>

                                <div className="pl-[16px] flex flex-row gap-3">
                                    <img alt="" src={financeAssets.ic_pending} className="w-[1.4rem] h-[1.4rem] self-center" />
                                    <span className="font-13-400 text-[#697DA4]">A aguardar reembolso</span>
                                </div>

                                <div className="pl-[16px] flex flex-row gap-3">
                                    <img alt="" src={financeAssets.ic_complete} className="w-[1.4rem] h-[1.4rem] self-center" />
                                    <span className="font-13-400 text-[#697DA4]">Recebido</span>
                                </div>

                                <div className="pl-[16px] flex flex-row gap-3">
                                    <img alt="" src={financeAssets.ic_error} className="w-[1.4rem] h-[1.4rem] self-center" />
                                    <span className="font-13-400 text-[#697DA4]">Rejeitado</span>
                                </div>
                            </div>
                        </Typography>
                    </Popover>
                </div>
            </div>

            {/* table part */}
            <TranscationTable refund={refund} setRefund={setRefund} details={details} setDetails={setDetails} setShowAll={setShowAll} showAll={showAll} expend={expend} setExpend={setExpend} />
        </div>
    );
}

export default Transcation;